import type {ItemType} from '@PosterWhiteboard/items/item/item.types';
import {useAppSelector} from '@/hooks';
import {getSingleActiveItemObjectOnPage} from '@Components/poster-editor/poster-editor-reducer';

export function useSingleActivePosterItem(pageId?: string): ItemType | null {
  const singleActiveItemObject = useAppSelector((state) => {
    return getSingleActiveItemObjectOnPage(state, pageId);
  });

  const activeItem = singleActiveItemObject ? window.posterEditor?.whiteboard?.getItemForId(singleActiveItemObject.uid) : null;
  if (!activeItem) {
    return null;
  }

  return activeItem;
}
